import { IBarValue, Data } from "./HorizontalBarsValueInterfaces";
import { localeFormattedNumber } from "utilities/utilities";

export const HorizontalBarValue = ({ bars, xScale }: IBarValue) => {
    return bars.map(({ data: { data, indexValue }, y, height }: Data, i: number) => {
        let total = 0;

        Object.values(data).forEach((value: number | string) => {
            if (typeof value === "number") {
                total += value;
            }
        });

        return (
            <g transform={`translate(${xScale(total as number)})`} key={`${indexValue}-${i}`}>
                <text
                    className="bar-total-label"
                    x={height - height / 1.1}
                    y={y + height / 2}
                    textAnchor="start"
                    alignmentBaseline="central"
                    style={{
                        fill: "rgb(51, 51, 51)",
                    }}
                >
                    {localeFormattedNumber(data.countryCode as string, total)}
                </text>
            </g>
        );
    });
};
